module.exports = __webpack_public_path__ + "static/media/supraja.713ab4aa.png";